export const nojaFormSentCacheKey = (slug: string) => {
  return `${slug}.nojaFormSent`
}

export const nojaAdDismissedCacheKey = (slug: string) => {
  return `${slug}.nojaAd`
}

export const businessDashboardAlertsLocalStorageKey = (slug: string) => {
  return `${slug}.dashboardAlerts.dismissedTypes`
}

export const referralDashboardCardDismissedCacheKey = (userId: number | string) => {
  return `referral.dashboardCard.dismissedByUser.${userId}`
}

export const ifInsuranceFormSentCacheKey = (slug: string) => {
  return `${slug}.ifInsuranceFormSent`
}

export const businessInvoiceFormCopyUseRefNumberKey = (slug: string) => {
  return `${slug}.invoiceForm.copy.useRefNumber`
}

export const dismissedAutomaticDebtCollectionStartLanderKey = (slug: string) => {
  return `${slug}.dismissedAutomaticDebtCollectionStartLander`
}

export const bookDemoDismissedCacheKey = (slug: string) => {
  return `${slug}.bookDemo.dismissed`
}
